import "./SinglePostTemplate.module.css"
import SystemHeader from "@/reusable_sections/Header"
import SinglePostTemplateSection from "./sections/SinglePostTemplateSection"
import Footer from "@/reusable_sections/Footer"

export default function SinglePostTemplatePage() {

  return (
    <div>
      <SystemHeader />
      <SinglePostTemplateSection />
      <Footer />
    </div>
  )
}
